<template>
  <div v-if="loading" class="loading-overlay" role="status">
    <div class="loading-card">
      <span class="spinner"></span>
      <span class="label">{{ $t("Carregando") }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingOverlay",
  props: {
    loading: { type: Boolean, required: true, default: false },
  },
};
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  inset: 0;
  background: rgba(243, 244, 246, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  backdrop-filter: blur(1px);
}

.loading-card {
  background: #ffffff;
  border: 1px solid rgba(226, 232, 240, 0.95);
  border-radius: 8px;
  box-shadow: 0 22px 55px rgba(15, 23, 42, 0.22);
  display: flex;
  align-items: center;
  gap: 18px;
  min-width: min(440px, calc(100vw - 32px));
  overflow: hidden;
  padding: 20px 22px;
  position: relative;
  color: #111827;
  font-weight: 700;
}

.loading-card::before {
  background: #525863;
  content: "";
  height: 3px;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.spinner {
  align-items: center;
  background: #f8fafc !important;
  background-image: none !important;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  display: inline-flex;
  flex: 0 0 62px;
  height: 62px;
  justify-content: center;
  position: relative;
  width: 62px;
}

.spinner::before {
  animation: loading-overlay-spin 0.85s linear infinite;
  border: 4px solid rgba(82, 88, 99, 0.18);
  border-radius: 50%;
  border-top-color: #525863;
  content: "";
  height: 38px;
  position: absolute;
  width: 38px;
}

.spinner::after {
  animation: loading-overlay-core-pulse 1.2s ease-in-out infinite;
  background: #525863;
  border-radius: 50%;
  box-shadow: 0 0 0 6px rgba(82, 88, 99, 0.14);
  content: "";
  height: 8px;
  position: absolute;
  width: 8px;
}

.label {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 10px;
  line-height: 1.2;
  min-width: 0;
}

.label::before {
  animation: loading-overlay-track-slide 1.15s ease-in-out infinite;
  background: #525863;
  border-radius: 999px;
  content: "";
  display: block;
  height: 4px;
  opacity: 0.85;
  order: 2;
  width: 42%;
}

.label::after {
  background: linear-gradient(#525863, #525863) left top / 78% 7px no-repeat,
    linear-gradient(#525863, #525863) left bottom / 54% 7px no-repeat;
  content: "";
  display: block;
  height: 21px;
  opacity: 0.16;
  order: 3;
}

@keyframes loading-overlay-spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes loading-overlay-core-pulse {
  0%,
  100% {
    opacity: 0.72;
    transform: scale(0.82);
  }

  50% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes loading-overlay-track-slide {
  0%,
  100% {
    transform: translateX(0);
  }

  50% {
    transform: translateX(138%);
  }
}
</style>
